module.exports = "../../../../platform/assets/pageMainIcon/icon-zhuangtai-2-green.svg";